import React, { Component } from 'react'

class Stats extends Component {

  render() {

    let { title, mainStat, stats, disclaimer, image } = this.props

    return (
      <section className='stats'>
        <div className='stats__inner'>
          <div className='stats__content'>
            <h4 dangerouslySetInnerHTML={{ __html: title }} />
            <div className='stats__main'>
              <p dangerouslySetInnerHTML={{ __html: mainStat.value }} />
              <span dangerouslySetInnerHTML={{ __html: mainStat.label }} />
            </div>
            { stats && 
              <div className='stats__items'>
                {stats.map((el, i) => (
                  <div className='stats__item' key={i}>
                    <p dangerouslySetInnerHTML={{ __html: el.value }} />
                    <span dangerouslySetInnerHTML={{ __html: el.label }} />
                  </div>
                ))}
              </div>
            }
            { disclaimer && <p className='stats__disclaimer' dangerouslySetInnerHTML={{ __html: disclaimer }} /> }
          </div>
          <div className='stats__image'>
            { image?.sourceUrl && <img src={image?.sourceUrl} alt={title} /> }
          </div>
        </div>
      </section>
    )
  }
}

export default Stats